import DraftEntityTypes from "../../../../../enums/draftEntityTypes";
import { type AppDispatch, type AppThunk } from "../../../../Application/globaltypes/redux";
import midnightService from "../../../../Application/services/midnightService/midnightService";
import {
  LockScormSuccess,
  ScormEditSuccess,
  ScormPublishSuccess,
} from "../../../../Application/services/realTimeNotification/events/library/libraryEvents";
import { beginAsyncOperation } from "../../../../Application/slices/asyncOperationSlice";

import { beginAction, failureAction, createDraftSuccess, updateBegin } from "../slices/EntityStateSlice";
import type { NotifyStepSettings } from "../../../../../interfaces";
import { TagsEnum } from "../../../../../interfaces/TagsEnum";
import DataService from "../../../../Application/services/dataServices/typedDataService";
import { type ScormFileRequest, type ScormPayload } from "../../services/types";
import { setLoaded } from "../slices/DetailsSlice";

export const lockItemAction =
  (id: number): AppThunk =>
  async (dispatch: AppDispatch) => {
    dispatch(beginAction());
    dispatch(beginAsyncOperation({ id, action: LockScormSuccess }));
    try {
      await midnightService.getEntityLock(DraftEntityTypes.Scorm, id);
    } catch (error) {
      dispatch(failureAction({ error: error as Error }));
    }
  };

export const publishItemAction =
  (id: number, notificationSettings?: NotifyStepSettings, notifyTypes?: number[]): AppThunk =>
  async (dispatch: AppDispatch) => {
    dispatch(beginAction());
    dispatch(beginAsyncOperation({ id, action: ScormPublishSuccess }));
    try {
      await midnightService.releaseLock(
        DraftEntityTypes.Scorm,
        id,
        notificationSettings ? { notificationSettings, notifyTypes } : undefined,
      );
    } catch (error) {
      dispatch(failureAction({ error: error as Error }));
    }
  };

export const discardItemAction =
  (id: number): AppThunk =>
  async (dispatch: AppDispatch) => {
    dispatch(beginAction());
    dispatch(beginAsyncOperation({ id, action: ScormPublishSuccess }));
    try {
      await midnightService.discardLock(DraftEntityTypes.Scorm, id);
    } catch (error) {
      dispatch(failureAction({ error: error as Error }));
    }
  };

export const updateTagsAction =
  (id: number, tags: string[], type: "labels" | "softwareApplications"): AppThunk =>
  async () => {
    const tagTypeMap = {
      labels: TagsEnum.Label,
      softwareApplications: TagsEnum.SoftwareApplication,
    };

    try {
      await DataService.scorm.saveTags(id, { tags, tagType: tagTypeMap[type] });
    } catch (error) {}
  };

export const createItemAction =
  (payload: ScormFileRequest): AppThunk =>
  async (dispatch: AppDispatch) => {
    dispatch(beginAction());
    try {
      const result = await midnightService.createLock(DraftEntityTypes.Scorm, payload);
      const entityId = result.data as number;
      dispatch(createDraftSuccess({ entityId }));
      dispatch(setLoaded());
    } catch (error) {
      dispatch(failureAction({ error: error as Error }));
    }
  };

export const updateItemAction =
  (payload: ScormPayload): AppThunk =>
  async (dispatch: AppDispatch) => {
    dispatch(updateBegin());
    dispatch(beginAsyncOperation({ id: payload.id!, action: ScormEditSuccess }));
    try {
      await DataService.scorm.updateData(payload.id!, payload);
    } catch (error) {
      dispatch(failureAction({ error: error as Error }));
    }
  };
